import {
  FacebookCustomAudienceEventSourceType,
  FacebookCustomAudienceFilter,
  FacebookCustomAudienceOperator,
  FacebookCustomAudienceRule,
  FacebookCustomAudienceRuleSet,
} from '../Rule';

export interface EngagedUsersAudienceRule extends FacebookCustomAudienceRule {
  inclusions: {
    operator: FacebookCustomAudienceOperator;
    rules: [
      {
        event_sources: [
          {
            id: string;
            type: FacebookCustomAudienceEventSourceType.PAGE;
          },
        ];
        filter?: FacebookCustomAudienceFilter;
        retention_seconds?: number;
        template?: string;
      },
      {
        event_sources: [
          {
            id: string;
            type: FacebookCustomAudienceEventSourceType.IG_BUSINESS;
          },
        ];
        filter?: FacebookCustomAudienceFilter;
        retention_seconds?: number;
        template?: string;
      },
      ...FacebookCustomAudienceRuleSet[]
    ];
  };
}

export const exampleEngagedUsersAudienceRule: EngagedUsersAudienceRule = {
  inclusions: {
    operator: 'or',
    rules: [
      {
        event_sources: [
          {
            type: FacebookCustomAudienceEventSourceType.PAGE,
            id: '123',
          },
        ],
        retention_seconds: 2592000,
      },
      {
        event_sources: [
          {
            type: FacebookCustomAudienceEventSourceType.IG_BUSINESS,
            id: '123',
          },
        ],
        retention_seconds: 2592000,
      },
    ],
  },
};
